import type { DatePickerProps } from './DatePicker'
import DatePicker from './DatePicker'

import styles from './DateStyles.module.css'

type PublicDatePickerProps = DatePickerProps & {
  /** antd-style alias for `date` */
  value?: Date | null
  /** antd-style alias for `onDateChange` */
  onChange?: (date: Date | null, dateString: string) => void
}

const DatePickerPerFlag = ({
  date,
  value,
  onChange,
  onDateChange,
  ...rest
}: PublicDatePickerProps) => {
  const currentDate = value !== undefined ? value : (date ?? null)

  return (
    <div className={styles.container}>
      <DatePicker
        date={currentDate}
        onDateChange={(d) => {
          onDateChange?.(d)
          onChange?.(d, '')
        }}
        {...rest}
      />
    </div>
  )
}

export default DatePickerPerFlag

export type { DatePickerProps }
